<!-- 渲染 -->
<form #validateForm="ngForm" nz-row nz-form [ngClass]="{ formBordered: !!rootComponent && !!rootComponent.bordered }">
  <div class="widget-form-list" style="width: 100%" *ngIf="rootComponent && rootComponent.children">
    <ng-container *ngFor="let subComponent of rootComponent.children; let i = index">
      <div
        nz-col
        [nzMd]="subComponent.span || 12"
        [nzXs]="24"
        [nzOffset]="subComponent.offset || 0"
        class="widget-form-list-item"
        [attr.data-id]="subComponent.id"
        [attr.id]="'widget-' + subComponent.id"
        style="display: inline-block; width: 100%; float: left"
      >
        <div>
          <r-widget-form-render [parentComponent]="rootComponent" [component]="subComponent"> </r-widget-form-render>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="showButton">
    <r-widget-button (resetForm)="_resetForm()" (submitForm)="_submitForm()"></r-widget-button>
  </div>
</form>
